import * as React from 'react';

export default function AspectRectangleIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 25 16" fill="none" {...props}>
      <path d="M1 1h23v14H1V1z" fill="#F5F0FF" />
      <path
        d="M5.555 0H1a1 1 0 00-1 1v4h1.5V1.5h4.055V0zM19.444 1.5V0H24a1 1 0 011 1v4h-1.5V1.5h-4.056zM19.444 14.5H23.5V11H25v4a1 1 0 01-1 1h-4.556v-1.5zM1.5 11v3.5h4.055V16H1a1 1 0 01-1-1v-4h1.5z"
        fill="currentColor"
      />
    </svg>
  );
}
